import Vue from 'vue';
import { createPinia as createPiniaStore, PiniaVuePlugin } from 'pinia';
import persist from './plugins/persist';

export default function createPinia() {
  Vue.use(PiniaVuePlugin);

  const pinia = createPiniaStore();
  pinia.use(persist);

  return pinia;
}
